import { currentUtcMonth, scanUsage } from '@splitfiesta/core';

import { useFeatureFlag } from '@/hooks/queries/useFeatureFlagsQuery';

import { useAuthStore } from '@/stores/authStore';

import { ScanUsageSection } from './ScanUsageSection';

/** A Pro user's scans show on the Pro card instead. */
export function ScanUsageSectionContainer() {
  const user = useAuthStore(state => state.user);
  const usage = scanUsage({
    flagOn: useFeatureFlag('pro'),
    user,
    nowMonth: currentUtcMonth(),
  });

  if (usage.kind !== 'counted') return null;
  return <ScanUsageSection used={usage.used} allowance={usage.allowance} />;
}
